import { GetPersonRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'configs';
import { useAuth } from 'providers';
import { useParticipantsPersonApi } from 'services';

export const useGetPerson = (request: GetPersonRequest) => {
  const { isAuthenticated } = useAuth();

  const { getPerson } = useParticipantsPersonApi();

  return useQuery({
    queryKey: [queryKeys.getPerson, { request }],
    queryFn: () => getPerson(request),
    enabled: isAuthenticated
  });
};
